import type { Language } from "@app/constants";

interface Messages {
	currencyCode: string;
	defaultValue: string;
	defaultValueMobile: string;
	groupSeparator: string;
	heading: string;
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		currencyCode: "R ",
		defaultValue: "R 0",
		defaultValueMobile: "R 0",
		groupSeparator: ",",
		heading: "Statistics",
	},
};

export default messages;
